module.exports = __webpack_public_path__ + "img/mtd-en.49458bdc.png";